module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/may-0ed24b72752afee5c3f1287419c20d07.png";